import {Product} from './product';
import {GetSafeValue} from '../../utils/get-safe-value';
import {StringFieldUtil} from '../../utils/string-field-util';
import {StringUtils} from '../../utils/string-utils';

export class Category extends Product {
  pid: string;

  constructor(){
    super();
    this.title = new Map();
    this.imageUrls = [];
    this.modifiedAt = StringUtils.getDateLocal(StringUtils.getDateUTC(new Date()));
  };

  static fromJson(data: Category){
    let category = new Category();
    category.fromJson(data);
    return category;
  }

  fromJson(data: Category){
    this.pid = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.pid], '');
    this.id = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.id], '');
    this.isEnable = GetSafeValue.getSafeValueAsBoolean(data[StringFieldUtil.isEnable], null);
    this.imageUrls = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.imageUrls], [], []);
    if(data[StringFieldUtil.title]){
      this.title = StringUtils.objToStrMap(data[StringFieldUtil.title]);
    }else {
      this.title = new Map();
    }
    this.modifiedAt = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.modifiedAt], undefined);
    this.itemCountTotal = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.itemCountTotal], 0);
  }

  static clone(category: Category){
    let objCategory = Object.assign(new Category(), category);
    objCategory.title = StringUtils.copyMap(category.title);

    return objCategory;
  }

  toMap() {
    return {
      "id" : this.id,
      "pid": this.pid,
      "title": StringUtils.strMapToObj(this.title),
      "isEnable": this.isEnable === null ? false : this.isEnable,
      "imageUrls": this.imageUrls,
      "modifiedAt" : this.modifiedAt,
      "itemCountTotal": this.itemCountTotal,
    };
  }
}
